import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { SessionStore } from './session.store';

const SESSION_CHECK_INTERVAL_MS = 30_000;

@Injectable({ providedIn: 'root' })
export class AuthSessionMonitorService {
  private readonly authService = inject(AuthService);
  private readonly sessionStore = inject(SessionStore);
  private readonly router = inject(Router);
  private intervalId: number | null = null;

  start(): void {
    if (this.intervalId !== null) {
      return;
    }

    this.intervalId = window.setInterval(() => {
      void this.verifySession();
    }, SESSION_CHECK_INTERVAL_MS);

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  private readonly handleVisibilityChange = (): void => {
    if (document.visibilityState === 'visible') {
      void this.verifySession();
    }
  };

  private async verifySession(): Promise<void> {
    if (!this.sessionStore.snapshot()) {
      return;
    }

    const isValid = await this.authService.ensureValidSession();
    if (isValid || this.router.url.startsWith('/login')) {
      return;
    }

    void this.router.navigate(['/login'], {
      queryParams: { redirectTo: this.router.url || '/' },
    });
  }
}
